import React from 'react'
import { useSelector } from 'react-redux'
import VideoTitle from './VideoTitle'
import VideoBackgroung from './VideoBackgroung'

const MainConatiner = () => {

    const movies = useSelector((store) => store.movies?.nowPlayingMovies);
    if(!movies) return; 
    const random = Math.floor(Math.random() * 20);
    const mainMovies = movies[random]
    

    const {original_title, overview, id} = mainMovies;
 
    return (
    <div className='pt-[30%] bg-black md:pt-0 w-full'>
       <VideoTitle title={original_title} overview={overview}/>
       <VideoBackgroung movieId ={id}/>
    </div>
  )
}

export default MainConatiner